import { useMutation } from '@tanstack/react-query';
import { User } from 'src/models/User';
import { httpClient } from 'src/utils/httpClient';

type IUpdatePassword = {
  code: string;
  email: string;
  password: string;
  confirmPassword: string;
};

type IVerifyCode = {
  code: string;
};

type IResetPassword = {
  email: string;
};

type IRegister = {
  email: string;
  password: string;
  firstName: string;
  lastName: string;
};

type ISendPhone = {
  phone: string;
  name: string;
  channel?: 'WEB' | 'QRMENU';
  shopId?: number;
}
type ISendCode = {
  verification_code: string;
  phone: string;
}

export class AuthRepository {
  login = (data: ISendCode) => httpClient.post('/app/customers/verify', data);
  getLoggedUser = () => httpClient.get<User>('/app/customers/me');

  updatePassword = (args: IUpdatePassword) =>
    new Promise((res) => {
      setTimeout(() => res('OK'), 4000);
    });

  verifyCode = (args: IVerifyCode) =>
    new Promise((res) => {
      setTimeout(() => res('OK'), 4000);
    });

  resetPassword = (args: IResetPassword) =>
    new Promise((res) => {
      setTimeout(() => res('OK'), 4000);
    });

  register = (args: IRegister) =>
    new Promise((res) => {
      setTimeout(() => res('OK'), 4000);
    });

  sendPhone = (phone: ISendPhone) => httpClient.post('/app/customers/send-verification-code', phone);
}

const repo = new AuthRepository();

export const useLoginMutation = () => useMutation({ mutationFn: repo.login });
export const useUpdatePasswordMutation = () => useMutation({ mutationFn: repo.updatePassword });
export const useVerifyCodeMutation = () => useMutation({ mutationFn: repo.verifyCode });
export const useResetPasswordMutation = () => useMutation({ mutationFn: repo.resetPassword });
export const useRegisterMutation = () => useMutation({ mutationFn: repo.register });

export const useSendPhoneMutation = () => useMutation({ mutationFn: repo.sendPhone });